import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap'
import { Form, Table } from 'rsuite';
import dashboardInformationService from '../../../services/Internal/Staff/dashboardInformation.service';
import { Link } from 'react-router-dom';
import { PiListMagnifyingGlassBold } from "react-icons/pi";


function DashboardChartApplicationStatusCounts() {
    const [displayLength, setDisplayLength] = useState(10);
    const [gridLoading, setGridLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [gridData, setGridData] = useState([]);
    const [searchModel, setSearchModel] = useState(
        {
            dateBegin: '',
            dateEnd: ''
        }
    );
    useEffect(() => {
        refreshData();
    }, [])
    const search = () => {
        refreshData();
    }
    const refreshData = () => {
        setGridLoading(true);
        dashboardInformationService.getDashboardApplicationStatusCounts(searchModel.dateBegin, searchModel.dateEnd).then((response) => {
            setGridData(response.data);
            setGridLoading(false);
        });
    }
    const getData = () => {
        return gridData.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        })
    }
    const clearSearchModel = () => {
        setSearchModel({
            dateBegin: '',
            dateEnd: ''
        });
    }
    return (
        <Card style={{ height: "100%" }}>
            <Card.Body>
                <div style={{ textAlign: 'center' }}><h5>Application Status <span style={{ textAlign: 'right' }}>{/*<Button as={Link} to="/internal/applicationInfo" className="ml-2" variant="link" fontSize='42'><PiListMagnifyingGlassBold /></Button>*/}</span></h5>
                </div>
                <Form fluid formValue={searchModel} onChange={setSearchModel} onSubmit={search} style={{marginBottom: '2rem' }}>
                    <Row>
                        <Col>
                            <Form.Group>
                                <Form.ControlLabel><b>Date Range</b></Form.ControlLabel>
                                <Form.Control name="dateBegin" type="date" block />
                            </Form.Group>
                        </Col>
                        <Col xs="auto" style={{ marginTop: '1.5em' }} className="d-flex align-items-center">to</Col>
                        <Col>
                            <Form.ControlLabel>&nbsp;</Form.ControlLabel>
                            <Form.Control name="dateEnd" type="date" block />
                        </Col>
                        <Col style={{ marginTop: '1.5rem' }}>
                            <Button type="submit">Search</Button>
                            <Button onClick={clearSearchModel} variant="danger" className="ms-2">Reset</Button>
                        </Col>
                    </Row>
                </Form>
                <Table
                    autoHeight
                    wordWrap
                    loading={gridLoading}
                    data={getData()} >
                    <Table.Column minWidth={100} flexGrow={1}>
                        <Table.HeaderCell>
                            <b>Application Type</b>
                        </Table.HeaderCell>
                        <Table.Cell dataKey="applicationType" />
                    </Table.Column>
                    <Table.Column minWidth={100} flexGrow={.5}>
                        <Table.HeaderCell>
                            <b>Received</b>
                        </Table.HeaderCell>
                        <Table.Cell dataKey="received" />
                    </Table.Column>
                    <Table.Column minWidth={100} flexGrow={.5}>
                        <Table.HeaderCell>
                            <b>Approved</b>
                        </Table.HeaderCell>
                        <Table.Cell dataKey="approved" />
                    </Table.Column>
                    <Table.Column minWidth={100} flexGrow={.5}>
                        <Table.HeaderCell>
                            <b>Declined</b>
                        </Table.HeaderCell>
                        <Table.Cell dataKey="declined" />
                    </Table.Column>
                </Table >
            </Card.Body>
        </Card>
    )
}

export default DashboardChartApplicationStatusCounts;